import button from './OAButton.vue'
const OAButton = {
  install: function (Vue) {
    Vue.component('OAButton', button)
  }
}
export default OAButton
